var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { plainToInstance, Type } from "class-transformer";
import { IsEmail, IsString, IsUUID, ValidateIf, ValidateNested } from "class-validator";
import { BaseDTO } from "../public";
import { ExposeFrontend } from "../../decorators";
export class RatingReport extends BaseDTO {
    static fromReportReviewRequest(reportReviewRequest) {
        const plain = Object.assign({ reports: [{ reason: reportReviewRequest.reason, email: reportReviewRequest.email }] }, reportReviewRequest);
        return plainToInstance(RatingReport, plain, { excludeExtraneousValues: true });
    }
}
__decorate([
    IsUUID(),
    ExposeFrontend()
], RatingReport.prototype, "ratingId", void 0);
__decorate([
    Type(() => Report),
    ValidateNested(),
    ExposeFrontend()
], RatingReport.prototype, "reports", void 0);
__decorate([
    IsUUID(),
    ExposeFrontend()
], RatingReport.prototype, "professorId", void 0);
export class Report {
}
__decorate([
    ValidateIf((r) => r.email !== ""),
    IsEmail(),
    ExposeFrontend()
], Report.prototype, "email", void 0);
__decorate([
    IsString(),
    ExposeFrontend()
], Report.prototype, "reason", void 0);
//# sourceMappingURL=RatingReport.js.map